import { useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";
import { apiUrl } from "../../../utils/config";

export const Contact = () => {
  const [form, setForm]       = useState({name:"",email:"",subject:"",message:""});
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult]   = useState(null); // 'success' | 'error'

  const h = e => setForm(p=>({...p,[e.target.name]:e.target.value}));
  const inputCls = "w-full px-4 py-3 border border-gray-200 rounded-xl text-sm bg-white";

  const submit = async () => {
    if (!form.name || !form.email || !form.message) return;
    setSubmitting(true);
    setResult(null);
    try {
      const res = await axios.post(`${apiUrl}/contacts`, { ...form, page_slug: "contact" });
      if (res.data.status) {
        setResult("success");
        setForm({name:"",email:"",subject:"",message:""});
      } else {
        setResult("error");
      }
    } catch (_) {
      setResult("error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <section className="bg-gradient-to-br from-[#111] to-gray-800 text-white py-20 px-4 text-center">
        <p className="text-sm font-bold text-[#f97316] uppercase tracking-wider mb-3">Reach Out</p>
        <h1 className="font-serif text-6xl mb-4">Get in <span className="text-[#f97316]">Touch</span></h1>
        <p className="text-gray-400 text-lg">Questions, feedback, corporate catering? We'd love to hear from you.</p>
      </section>

      <div className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <h2 className="font-serif text-2xl text-gray-900 mb-6">Send a Message</h2>
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-xs font-bold text-gray-500 mb-1 block">Your Name *</label><input name="name" value={form.name} onChange={h} placeholder="Full name" className={inputCls}/></div>
              <div><label className="text-xs font-bold text-gray-500 mb-1 block">Email *</label><input name="email" value={form.email} onChange={h} type="email" placeholder="email@example.com" className={inputCls}/></div>
            </div>
            <div><label className="text-xs font-bold text-gray-500 mb-1 block">Subject</label>
              <select name="subject" value={form.subject} onChange={h} className={inputCls}>
                <option value="">Select a topic...</option>
                <option value="order">Order Issue</option>
                <option value="feedback">Food Feedback</option>
                <option value="corporate">Corporate Catering</option>
                <option value="partnership">Partnership</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div><label className="text-xs font-bold text-gray-500 mb-1 block">Message *</label><textarea name="message" value={form.message} onChange={h} rows={5} placeholder="Tell us how we can help..." className={inputCls+" resize-none"}/></div>
            {result === "success" && (
              <div className="bg-green-50 border border-green-200 text-green-700 text-sm font-medium px-4 py-3 rounded-xl">
                ✅ Message sent! We'll get back to you soon.
              </div>
            )}
            {result === "error" && (
              <div className="bg-red-50 border border-red-200 text-red-600 text-sm font-medium px-4 py-3 rounded-xl">
                ❌ Something went wrong. Please try again.
              </div>
            )}
            <button
              onClick={submit}
              disabled={submitting || !form.name || !form.email || !form.message}
              className="bg-gradient-to-r from-[#f97316] to-red-500 text-white font-black px-8 py-4 rounded-2xl hover:shadow-xl hover:shadow-orange-200 transition-all btn-press w-full disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting ? "Sending…" : "Send Message 📨"}
            </button>
          </div>
        </div>

        <div className="md:col-span-3 space-y-4">
          <h2 className="font-serif text-2xl text-gray-900 mb-6">Contact Info</h2>
          {[["📍","Address","123 Food Street, Banjara Hills, Hyderabad, Telangana 500034"],["📞","Phone","+91 98765 43210"],["✉️","Email","hello@gamapafoods.com"],["⏰","Hours","Mon–Sun: 7:00 AM – 11:00 PM"],["🚀","Delivery","Hyderabad & surrounding areas"]].map(([e,t,c]) => (
            <div key={t} className="flex gap-4 bg-white rounded-2xl p-4 border border-gray-100 shadow-sm card-hover">
              <span className="text-2xl flex-shrink-0">{e}</span>
              <div><p className="font-bold text-gray-900 text-sm">{t}</p><p className="text-gray-500 text-sm leading-relaxed">{c}</p></div>
            </div>
          ))}
          <div className="bg-orange-50 rounded-2xl p-5 border border-orange-100">
            <h3 className="font-bold text-gray-900 mb-3 text-sm">Corporate Catering</h3>
            <p className="text-xs text-gray-500 mb-3">Feeding your team? We do office catering for 10–500 people with custom menus and dedicated account managers.</p>
            <button className="bg-[#f97316] text-white font-bold px-5 py-2.5 rounded-xl text-sm btn-press hover:bg-orange-600 transition-colors">Enquire Now</button>
          </div>
        </div>
      </div>
        <Footer />
    </div>
  );
};